import lang from "@/views/modules/EmailTemplates/language/en";
export default {
    name: "list-email-templates",
    components: {
    },
    data() {
        return {
            page: 1,
            search: '',
            sort: {
                order: 'desc',
                column: 'date_entered',
            },
            perPage: 10,
            loading: true,
            exampleList: [],
            pagination: {
                currentPage: 0,
                perPage: 0,
                total: 0,
                totalPages: 0
            },
            lang:[],
        }
    },
    mounted() {
        this.getBudgethead();
        this.lang = lang;
    },
    methods: {
        changePage(page) {
            const self = this;
            if ((page > 0) && (page <= self.pagination.totalPages) && (page !== self.page)) {
                self.page = page;
                self.getBudgethead();
            }
        },
        changeSort() {
            const self = this;
            if (self.sort.order === 'asc') {
                self.sort.order = 'desc';
            } else if (self.sort.order === 'desc') {
                self.sort.order = 'asc';
            }
            self.getBudgethead();
        },
        getBudgethead() {
            const self = this;
            self.loading = true;
             window.currentAction = 'list';
                axios.get('api/modules/emailtemplates', {
                params: {
                    page: self.page,
                    sort: self.sort,
                    search: self.search,
                    perPage: self.perPage
                }
            }).then(function (response) {
                self.exampleList = response.data.items;
                self.pagination = response.data.pagination;
                if (self.pagination.totalPages < self.pagination.currentPage) {
                    self.page = self.pagination.totalPages;
                    self.getBudgethead();
                } else {
                    self.loading = false;
                }
            }).catch(function () {
                self.loading = false;
            });
        },
    }
}